var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "scp-welcome-backdrop",
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "scp-welcome-modal",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "scp-welcome-title",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _vm.dismissible
                ? _c(
                    "button",
                    {
                      staticClass: "scp-welcome-close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_vm._v(" × ")]
                  )
                : _vm._e(),
              _c("header", { staticClass: "scp-welcome-head" }, [
                _vm._m(0),
                _c(
                  "div",
                  {
                    staticClass: "scp-welcome-tabs",
                    attrs: {
                      role: "tablist",
                      "aria-label": "Welcome sections",
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "scp-welcome-tab",
                        class: { "is-active": _vm.activeTab === "start" },
                        attrs: {
                          id: "scp-welcome-tab-start",
                          type: "button",
                          role: "tab",
                          "aria-selected":
                            _vm.activeTab === "start" ? "true" : "false",
                          "aria-controls": "scp-welcome-panel-start",
                        },
                        on: {
                          click: function ($event) {
                            _vm.activeTab = "start"
                          },
                        },
                      },
                      [_vm._v(" Start SCOPE ")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "scp-welcome-tab",
                        class: { "is-active": _vm.activeTab === "learn" },
                        attrs: {
                          id: "scp-welcome-tab-learn",
                          type: "button",
                          role: "tab",
                          "aria-selected":
                            _vm.activeTab === "learn" ? "true" : "false",
                          "aria-controls": "scp-welcome-panel-learn",
                        },
                        on: {
                          click: function ($event) {
                            _vm.activeTab = "learn"
                          },
                        },
                      },
                      [_vm._v(" Learn SCOPE ")]
                    ),
                  ]
                ),
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab === "start",
                      expression: "activeTab === 'start'",
                    },
                  ],
                  staticClass: "scp-welcome-panel",
                  attrs: {
                    id: "scp-welcome-panel-start",
                    role: "tabpanel",
                    "aria-labelledby": "scp-welcome-tab-start",
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "scp-welcome-option scp-welcome-option-import scp-welcome-import-top",
                      attrs: { type: "button" },
                      on: { click: _vm.onImportSessionClick },
                    },
                    [
                      _c("span", { staticClass: "scp-welcome-option-title" }, [
                        _vm._v("Import session"),
                      ]),
                      _c("span", { staticClass: "scp-welcome-option-desc" }, [
                        _vm._v(
                          " Load a previously exported session and pick up where you left off. "
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "scp-welcome-option scp-welcome-search-wrapper",
                    },
                    [
                      _c("span", { staticClass: "scp-welcome-option-title" }, [
                        _vm._v("Hypothesis"),
                      ]),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.hypothesisText,
                            expression: "hypothesisText",
                          },
                        ],
                        staticClass: "scp-welcome-textarea",
                        attrs: {
                          rows: "4",
                          placeholder:
                            "e.g. Knocking down GENE1 in HepG2 cells reduces expression of GENE2 under hypoxia",
                        },
                        domProps: { value: _vm.hypothesisText },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.hypothesisText = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                  _c("div", { staticClass: "scp-welcome-options" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "scp-welcome-option scp-welcome-option-action",
                        attrs: {
                          type: "button",
                          disabled: !_vm.hypothesisText.trim(),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onOptionSelect("evaluateHypothesis")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "scp-welcome-option-title" },
                          [_vm._v("Evaluate hypothesis")]
                        ),
                        _c("span", { staticClass: "scp-welcome-option-desc" }, [
                          _vm._v(
                            " Checks the hypothesis for precision and falsifiability and shows the parsed target, perturbation, and outcome. Flags anything it can't confidently score instead of guessing. "
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass:
                          "scp-welcome-option scp-welcome-option-action",
                        attrs: {
                          type: "button",
                          disabled: !_vm.hypothesisText.trim(),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onOptionSelect("evaluateAndSearchKg")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "scp-welcome-option-title" },
                          [_vm._v("Evaluate hypothesis + Search CFDE KG")]
                        ),
                        _c("span", { staticClass: "scp-welcome-option-desc" }, [
                          _vm._v(
                            " Scores the hypothesis first, then searches the CFDE knowledge graph for gene–trait evidence using the parsed target and outcome. "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab === "learn",
                      expression: "activeTab === 'learn'",
                    },
                  ],
                  staticClass: "scp-welcome-panel",
                  attrs: {
                    id: "scp-welcome-panel-learn",
                    role: "tabpanel",
                    "aria-labelledby": "scp-welcome-tab-learn",
                  },
                },
                [
                  _c("p", { staticClass: "scp-welcome-intro" }, [
                    _vm._v(
                      " SCOPE is a hub-and-spoke workbench, not a linear pipeline. Once a hypothesis is parsed, run any of the four modules, in any order: "
                    ),
                  ]),
                  _vm._m(1),
                  _vm._m(2),
                ]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "h2",
      { staticClass: "scp-welcome-title", attrs: { id: "scp-welcome-title" } },
      [
        _vm._v(" Welcome to "),
        _c("span", { staticClass: "scp-welcome-brand" }, [
          _c("span", { staticClass: "scp-welcome-mark" }, [_vm._v("REVEAL")]),
          _c("span", { staticClass: "scp-welcome-name" }, [_vm._v("SCOPE")]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "scp-welcome-options" }, [
      _c("div", { staticClass: "scp-welcome-option" }, [
        _c("span", { staticClass: "scp-welcome-option-title" }, [
          _vm._v("A · Quality & Syntax"),
        ]),
        _c("span", { staticClass: "scp-welcome-option-desc" }, [
          _vm._v(
            " Real-time rubric on precision and falsifiability, plus a slot inspector to review or correct the parse. "
          ),
        ]),
      ]),
      _c("div", { staticClass: "scp-welcome-option" }, [
        _c("span", { staticClass: "scp-welcome-option-title" }, [
          _vm._v("B · Literature Launcher"),
        ]),
        _c("span", { staticClass: "scp-welcome-option-desc" }, [
          _vm._v(" Editable search query and deep link to PubMed. "),
        ]),
      ]),
      _c("div", { staticClass: "scp-welcome-option" }, [
        _c("span", { staticClass: "scp-welcome-option-title" }, [
          _vm._v("C · KG Evidence & Path Finder"),
        ]),
        _c("span", { staticClass: "scp-welcome-option-desc" }, [
          _vm._v(
            " Per-hop evidence against curated knowledge graphs, with coverage metadata on every result. "
          ),
        ]),
      ]),
      _c("div", { staticClass: "scp-welcome-option" }, [
        _c("span", { staticClass: "scp-welcome-option-title" }, [
          _vm._v("D · Dataset & Workspace Provisioner"),
        ]),
        _c("span", { staticClass: "scp-welcome-option-desc" }, [
          _vm._v(
            " Hand off a gap to existing datasets or a generation protocol template. "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "scp-welcome-intro" }, [
      _c("strong", [_vm._v("Bounded honesty:")]),
      _vm._v(
        " SCOPE only answers as much as it knows, and always states its coverage explicitly. "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }